"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodType = void 0;
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["UNKNOWN"] = "unknown";
    PaymentMethodType["CARD"] = "card";
})(PaymentMethodType || (exports.PaymentMethodType = PaymentMethodType = {}));
